// Marketing copy for the pricing section. Numbers / prices always come from /api/public/plans.
export const PLAN_COPY = {
  clinic: {
    tagline: 'For independent audiology clinics',
    intro: 'All features included:',
    features: [
      'Patient records', 'Audiology tests and reports', 'Appointments', 'Hearing aid trials and sales',
      'Inventory (serialised and non-serialised)', 'Service and repair tracking', 'Referral doctor payouts',
      'Revenue dashboard', 'GST invoicing', 'Data import and export',
    ],
    cta: 'Start with Clinic',
  },
  chain: {
    tagline: 'For multi-branch practices',
    intro: 'Everything in Clinic, plus:',
    features: ['Consolidated reports across branches', 'Central inventory with stock transfer', 'Branch-wise revenue comparison'],
    cta: 'Start with Chain',
  },
  enterprise: {
    name: 'Enterprise',
    tagline: 'For hospitals and large networks',
    intro: 'Everything in Chain, plus:',
    features: ['Dedicated onboarding', 'Priority support', 'Custom integrations'],
    cta: 'Talk to us',
  },
};

export const inr = (n) => `₹${Number(n || 0).toLocaleString('en-IN')}`;

export const pricingFaq = (d) => {
  const f = d?.founding || {};
  const user = d?.addons?.extra_user?.monthly_price;
  const waived = (d?.onboarding_fee?.waived_cycles || []).includes('annual');
  return [
    { q: 'Can I change my plan later?', a: 'Yes. Upgrade anytime — you only pay the difference for the days left in your billing period. Downgrades take effect at the end of your current period.' },
    { q: 'What happens if I need more users?', a: `Add extra users at ${inr(user)}/month each, anytime from your subscription page.` },
    { q: 'Is my data safe if I stop subscribing?', a: 'Yes. Your data is never deleted when a plan ends — you can always view and export all of it.' },
    { q: 'What is the founding offer?', a: `${f.discount_percent}% off annual plans, with your price locked for your first ${f.locked_renewals} renewals — for the first ${f.limit} clinics only.` },
    { q: 'Do you provide training?', a: `Yes — on-site onboarding and staff training${waived ? ', free on annual plans' : ''}.` },
  ];
};
